var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_153994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4285 5.99995V2.39995C19.4285 2.08169 19.3081 1.77647 19.0938 1.55142C18.8795 1.32638 18.5888 1.19995 18.2857 1.19995H3.42854C2.82233 1.19995 2.24095 1.45281 1.81229 1.90289C1.38364 2.35298 1.14282 2.96343 1.14282 3.59995C1.14282 4.23647 1.38364 4.84692 1.81229 5.29701C2.24095 5.74709 2.82233 5.99995 3.42854 5.99995H20.5714C20.8745 5.99995 21.1652 6.12638 21.3795 6.35142C21.5938 6.57647 21.7142 6.88169 21.7142 7.19995V12M21.7142 12H18.2857C17.6795 12 17.0981 12.2528 16.6694 12.7029C16.2408 13.153 16 13.7634 16 14.4C16 15.0365 16.2408 15.6469 16.6694 16.097C17.0981 16.5471 17.6795 16.8 18.2857 16.8H21.7142C22.0174 16.8 22.308 16.6735 22.5224 16.4485C22.7367 16.2234 22.8571 15.9182 22.8571 15.6V13.2C22.8571 12.8817 22.7367 12.5765 22.5224 12.3514C22.308 12.1264 22.0174 12 21.7142 12Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14282 3.6001V20.4001C1.14282 21.0366 1.38364 21.6471 1.81229 22.0972C2.24095 22.5472 2.82233 22.8001 3.42854 22.8001H20.5714C20.8745 22.8001 21.1652 22.6737 21.3795 22.4486C21.5938 22.2236 21.7142 21.9184 21.7142 21.6001V16.8001",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_153994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/BillingIcon.f8c7d3104f09485b7837cb2af568c257.svg";
export { ForwardRef as ReactComponent };